<template>
  <div class="fullscreen_image_wrapper">
    <img src="@/assets/img/lockscreen.png" alt="" />

    <p class="info">Lock Reason: {{ this.reason.code || "unknown" }}</p>

    <button
      v-if="printing_locks.includes(this.reason.code)"
      class="reprint"
      :disabled="printing"
      @click="printReceipt()"
    >
      Reprint
    </button>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import OrderkioskApi from "@/api/orderkiosk";
import { commence_update, update_state } from "@/api/deployment";
import { setupRemoteStorageAssortment } from "@/utils/assortment";

export default {
  name: "Lock",
  computed: {
    ...mapGetters({
      allProducts: "PRODUCTS",
      locked: "LOCKED",
      reason: "LOCK_REASON",
      update_required: "UPDATE_REQUIRED"
    })
  },
  data() {
    return {
      check_interval: null,
      printing_locks: [
        "PAPER_END",
        "CUSTOMER_PRINTER_ERROR",
        "PRINTER_TIMEOUT"
      ],
      printing: false
    };
  },
  created() {
    this.check_interval = setInterval(this.check_lock, 5000);
    update_state();
  },
  beforeDestroy() {
    update_state();
    clearInterval(this.check_interval);
  },
  methods: {
    ...mapMutations({
      setProducts: "SET_PRODUCTS",
      unlock: "UNLOCK",
      setCustomerPrinterResponse: "SET_CUSTOMER_PRINTER_RESPONSE"
    }),
    ...mapActions({
      logAudit: "LOG_AUDIT",
      logRouter: "LOG_ROUTER",
      setPolelight: "SET_POLELIGHT"
    }),
    check_lock() {
      if (this.reason.code === "NoPuckLeft") {
        OrderkioskApi.getPuckInfo().then(r => {
          if (r.data.puckCount > 0) {
            this.unlock();
          }
        });
      }
      if (this.reason.code === "RemoteStorageTimeout") {
        setupRemoteStorageAssortment(
          this.allProducts,
          this.setProducts,
          this.$store,
          { retry: false }
        )
          .then(result => {
            if (result.ok) {
              this.unlock();
            }
          })
          .catch(err => {
            console.log("Failed to restore remote storage assortment:", err);
          });
      }
    },
    printReceipt() {
      this.printing = true;
      OrderkioskApi.reprintReceipt().then(res => {
        if (!this.printing_locks.includes(res.data.print_response)) {
          this.setCustomerPrinterResponse(res.data.print_response);
          this.setPolelight("green");
          this.unlock();
        } else {
          console.error("Customer Receipt Error:", res.data);
        }
        this.printing = false;
      });
    },
    doUpdate() {
      console.log("Updating...");
      commence_update();
    }
  },
  watch: {
    locked(newVal) {
      if (!newVal) {
        //we got unlocked.
        this.logRouter({ name: "home", router: this.$router });
      }
    },
    update_required(newVal) {
      if (newVal) {
        this.doUpdate();
      }
    }
  }
};
</script>

<style scoped>
.fullscreen_image_wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 1080px;
  height: 1920px;
  margin: 0;
  padding: 0;
}

.info {
  position: absolute;
  bottom: 0;
  width: 100%;
  text-align: center;
}

.reprint {
  position: absolute;
  bottom: 0;
  left: 0;
  margin: 1em;
  font-size: 2rem;
  padding: 0.5em 1em;
  border: none;
  border-radius: 100px;
}
</style>
